import ClickOutside from 'vue-click-outside';
import { ObserveVisibility } from 'vue-observe-visibility';
import NotificationList from '@/components/notifications/NotificationList/NotificationList.vue';

export default {
  props: {
    sortedNotifications: Object,
    notificationsPage: Number,
    notificationsCount: Number,
    isNotificationsLoading: Boolean
  },

  methods: {
    blur() {
      this.$emit('notificationsDropdownBlur');
    }
  },

  components: {
    ClickOutside,
    NotificationList
  },

  directives: {
    ClickOutside,
    ObserveVisibility
  }
};
